import { BiUserCircle } from "react-icons/bi";
import { GrGroup } from "react-icons/gr";

import { FiCalendar, FiHome } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";

import FlexBox from "../../components/common/FlexBox";
import { H6 } from "../../components/common/Headings";
import {
  DAVYS_GREY_400,
  DAVYS_GREY_600,
  PRIMARY_800,
} from "../../components/common/colors";
import { trackEvent } from "../../helperFunctions";
import useFeatureFlags from "../../hooks/useFeatureFlags";
import { CF_PROVIDER_ROLE } from "../../variable";

const Container = styled(FlexBox)`
  height: 4.5rem;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 0 0.5rem 0.25rem #0000000a;
  border-radius: 1rem 1rem 0 0;
  border-top: 1px solid ${DAVYS_GREY_400};
  z-index: 1;
`;

const links = [
  {
    title: "Dashboard",
    slug: "dashboard",
    Icon: FiHome,
    link: "/dashboard",
  },
  {
    title: "Clients",
    slug: "clients",
    Icon: BiUserCircle,
    link: "/clients",
  },
  {
    title: "Groups",
    slug: "groups",
    Icon: GrGroup,
    link: "/groups",
  },
  {
    title: "Availability",
    slug: "availability",
    Icon: FiCalendar,
    link: "/profile?currentOption=availability",
  },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const providerProfile = useSelector(state => state.provider.providerProfile);
  const isCfProvider = providerProfile?.roles?.some(role =>
    CF_PROVIDER_ROLE.includes(role)
  );

  const [isDashboardListingEnabled, isCalendarEnabled, isAvailabilityEnabled] =
    useFeatureFlags([
      "twa_private_session_listing_dashboard",
      "twa_private_google_calender_auth",
      "twa_private_availability",
    ]);

  const isDashboardRouteEnabled =
    isDashboardListingEnabled || isCalendarEnabled;

  // Hides "Groups" tab for normal Amaha providers; only visible for CF providers
  const filteredLinks = links.filter(link => {
    switch (link.slug) {
      case "dashboard":
        return isDashboardRouteEnabled;
      case "groups":
        return isCfProvider;
      case "availability":
        return isAvailabilityEnabled;
      default:
        return true;
    }
  });

  return (
    <Container>
      {filteredLinks.map(({ title, Icon, link, slug }) => {
        // Split the link into path and search parts
        const [path, search] = link.split("?");
        // Check if pathname matches and also handle query match if needed
        const selected =
          location.pathname === path &&
          (!search || location.search.includes(search));
        const currentTab =
          filteredLinks.find(
            link => location.pathname === link.link.split("?")[0]
          )?.slug || "";

        return (
          <FlexBox
            key={title}
            column
            align="center"
            onClick={() => {
              trackEvent({
                event: "twa_tab_change",
                payload: {
                  current_tab: currentTab,
                  new_tab: slug,
                },
              });
              navigate(link);
            }}
          >
            <Icon size="2rem" color={selected ? PRIMARY_800 : DAVYS_GREY_600} />
            <H6 bold color={selected ? PRIMARY_800 : DAVYS_GREY_600}>
              {title}
            </H6>
          </FlexBox>
        );
      })}
    </Container>
  );
};

export default BottomNav;
